import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqOverSrgCprStore', Object.keys(getters)),
	...mapState('pqOverSrgCprStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqOverSrgCprStore', Object.keys(actions)),
	...mapMutations('pqOverSrgCprStore', Object.keys(mutations))
};
